import GameModel from '../../../../vendor_core/core/src/model/GameModel';
import SpinModel from '../../../../vendor_core/core/src/model/SpinModel';
import SaveRestoreStateRequest from '../../../../vendor_core/src/server/requests/SaveRestoreStateRequest'
import Configs from '../../../../vendor_core/src/vendorConfigs/Configs';

export default class CCSaveRestoreStateRequest extends SaveRestoreStateRequest {
    get requestData() {
        GameModel.incrementRestoreVersion();
        let lastRestoreVersion = GameModel.restoreVersion;
        let index =
            SpinModel.currentGeneration && SpinModel.generations
            ? SpinModel.generations[SpinModel.currentGeneration].index
            : 0;
        let state = JSON.stringify({
            generation: index,
            roundFinished: SpinModel.roundFinish,
            restoreVersion: GameModel.restoreVersion,
            featureMode: SpinModel.featureMode
        });

        return {
            g: Configs?.vendorServer?.gameId || "",
            restoreState: state,
            restoreVersion: lastRestoreVersion,
            sid: GameModel.sessionID
        };
    }
}
